export default theme =>({
    root:{
        padding: theme.spacing.unit * 3,
        [theme.breakpoints.down('xs')]: {
            padding: theme.spacing.unit * 2
        },
    }

})